// https://github.com/jkuri/ng2-datepicker/tree/master/src/ng2-datepicker
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

import {ConfirmDialogComponent} from "./confirm-dialog.component";

@NgModule({
  declarations: [
    ConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    ConfirmDialogComponent,
    FormsModule,
  ],
  entryComponents: [
    ConfirmDialogComponent,
  ],
})
export class ConfirmDialogModule {
}
